import { AuthorisationFormValues } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { excludeDeleted } from 'shared/lib/common-util'
import { createAuthorisations } from '../api/createAuthorisations'
import { updateAuthorisations } from '../api/updateAuthorisations'
import { ErrorResult } from '../../../../shared/models/types'
import { BadRequestResponse } from '../../../../types/Errors'
import { Authorisation } from '../models/types'
import { toAuthorisationUpdates } from '../models/mapper'

function useSaveAuthorisationFormValues() {
  const saveAuthorisations = async (transitOperationId: number, authorisationFormValues: AuthorisationFormValues[]) => {
    let saved: Authorisation[] = []
    const errors: ErrorResult[] = []
    const formValues = authorisationFormValues.filter(excludeDeleted)
    if (!formValues.length) {
      return {
        saved,
        errors,
      }
    }

    const createRequests = []
    const updateRequests = []

    const updates = toAuthorisationUpdates(transitOperationId, formValues)
    for (const update of updates) {
      if (update.id != null) {
        updateRequests.push(update)
      } else {
        createRequests.push(update)
      }
    }

    const settledAuthorisationPromises = await Promise.allSettled([
      createAuthorisations(createRequests),
      updateAuthorisations(updateRequests),
    ])

    const rejectedDocumentPromises = settledAuthorisationPromises.filter((result): result is PromiseRejectedResult => result.status === 'rejected')
    rejectedDocumentPromises.forEach((result) => {
      const errorResponseData = result.reason?.response?.data
      if (errorResponseData?.message === 'CONSTRAINT_VIOLATION') {
        errorResponseData?.errors.forEach((errorItem: BadRequestResponse) => {
          errors.push({
            message: errorResponseData.message,
            field: errorItem.field,
            code: errorItem.reason,
          })
        })
      }
    })

    saved = settledAuthorisationPromises.filter((promise): promise is PromiseFulfilledResult<Authorisation[]> => promise.status !== 'rejected')
      .flatMap((promise) => promise.value)

    return {
      saved,
      errors,
    }
  }

  return {
    saveAuthorisations,
  }
}

export default useSaveAuthorisationFormValues
